import { Button } from "../../components/ui/button";
import { Textarea } from "../../components/ui/textarea";
import { Send, Loader2, Paperclip, X } from "lucide-react";

export function UpdateForm({
  newUpdate, setNewUpdate, updateFile, setUpdateFile,
  handleAddUpdate, submitting, updateFileInputRef, t,
}) {
  return (
    <form onSubmit={handleAddUpdate} className="mb-8">
      <div className="update-input-box rounded-xl p-4 shadow-sm">
        <Textarea
          data-testid="update-content-input"
          value={newUpdate}
          onChange={(e) => setNewUpdate(e.target.value)}
          placeholder={t("project.updatePlaceholder")}
          rows={3}
          className="border-0 bg-transparent resize-none mb-3 focus:ring-0"
        />

        {updateFile && (
          <div className="flex items-center gap-2 mb-3 p-2 bg-cyan-50/50 rounded-lg border border-cyan-100">
            <Paperclip className="w-4 h-4 text-cyan-500" />
            <span className="text-sm text-slate-600 flex-1 truncate">{updateFile.name}</span>
            <button type="button" onClick={() => setUpdateFile(null)} className="text-slate-400 hover:text-slate-600">
              <X className="w-4 h-4" />
            </button>
          </div>
        )}

        <div className="flex items-center justify-between">
          <div>
            <input
              ref={updateFileInputRef}
              type="file"
              className="hidden"
              onChange={(e) => setUpdateFile(e.target.files?.[0] || null)}
            />
            <Button type="button" variant="outline" size="sm" onClick={() => updateFileInputRef.current?.click()} className="text-slate-500">
              <Paperclip className="w-4 h-4 mr-1" />
              {t("project.attach")}
            </Button>
          </div>
          <Button type="submit" data-testid="submit-update-btn" disabled={submitting || !newUpdate.trim()} className="bg-indigo-600 hover:bg-indigo-500 btn-scale text-white">
            {submitting ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <>
                <Send className="w-4 h-4 mr-1" />
                {t("project.post")}
              </>
            )}
          </Button>
        </div>
      </div>
    </form>
  );
}
